module.exports = __webpack_public_path__ + "static/media/uk.12a83963.svg";